export default __webpack_public_path__ + "static/media/team_nabil.68ffc2a6.jpg";